<template>
    <v-layout row wrap class="account_content">
        <v-flex xs12 class="custom_flex_title">
            <h3>Mon profil</h3>
        </v-flex>
        <v-flex xs12>
            <account-profil />
        </v-flex>
    </v-layout>
</template>

<script>
    import AccountProfil from './accountProfil';

    export default {
        name: 'AccountContent',
        components: { AccountProfil }
    };
</script>

<style scoped>
    .account_content {
        margin: 20px !important;
        background-color: white;
        border-radius: 5px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }

    .custom_flex_title {
        padding-bottom: 10px !important;
        padding-top: 10px !important;
        border-bottom: 1px #80808096 solid;
        margin-bottom: 10px !important;
    }
</style>
